document.addEventListener('DOMContentLoaded', function () {
    const articleContents = document.getElementById('artikelinhalte');
    const tables = document.getElementsByTagName('table');
    for (let table of tables) {
        let hasMarginalia = false;
        const tds = table.getElementsByTagName('td');
        for (let td of tds) {
            for (let child of td.children) {
                child.classList.remove('lg:w-[630px]');
                if (child.classList.contains('marginalie')) {
                    hasMarginalia = true;
                }
            }
        }

        if (table.clientWidth > articleContents.clientWidth) {
            table.classList.add('mr-[50px]');

            const parent = table.parentNode;
            parent.classList.add('overflow-x-auto');

            const parentOfParent = parent.parentNode;
            if (!hasMarginalia) {
                parentOfParent.classList.remove('lg:w-[630px]');
                parentOfParent.classList.add('w-full');
            }

            const classNames = 'relative after:content-normal after:absolute after:top-0 after:-right-px after:bottom-0 after:w-[50px] after:bg-gradient-to-r from-transparent to-white';
            parentOfParent.classList.add(...classNames.split(' '));
        }
    }
});
